<template>
  <div>
    <div
      v-for="fieldKey in _fieldsKey"
      :key="fieldKey"
    >
      <WsCompareTableItem
        v-if="fields[fieldKey].isValueComparable"
        :field='fields[fieldKey]'
        :firstValue='$_getFormattedValue(fieldKey, true)'
        :secondValue='$_getFormattedValue(fieldKey, false)'
        :isUpdate="isUpdate"
        :updateData="updateData"
        :errorMessage="$_getErrorMessage(fieldKey)"
        :parentState="$_getParentState(fieldKey,fields)"
        :id="modelData ? modelData.id : ''"
        :value="$_getValue(fieldKey)"
        @input="$_onInput(fieldKey,$event)"
        @input-item="$emit('input-item', {fieldKey: `${fieldKey}Item`, value:$event})"
      />
      <WsContent v-else class="ml-3">
        <template>
          <WsInfo
            :fields="fields[fieldKey]"
            :type="fields[fieldKey].type"
            :label="`${fields[fieldKey].label}`"
            :getValue="fields[fieldKey].getValue"
            :value="getValueFunction.getSecondValue(modelData, fieldKey)"
            :getText="fields[fieldKey].getText"
            :originData="modelData"
          />
        </template>
      </WsContent>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      fields: {
        type: Object,
      },
      modelData: {
        type: Object,
      },
      updateData: {
        type: Object,
      },
      isUpdate: {
        type: Boolean,
        default: false,
      },
      errorMessages: {
        type: Object,
        default: null,
      },
      getValueFunction: {
        type: Object,
        default: function (){
          return {
            getFirstValue: function(modelData, fieldKey){
              return modelData[fieldKey] !== undefined
              ? modelData[fieldKey]
              : null
            },
            getSecondValue: function(modelData, fieldKey){
              return modelData[fieldKey] !== undefined
              ? modelData[fieldKey]
              : null
            }
          }
        }
      },
    },
    computed: {
      _fieldsKey() {
        return Object.keys(this.fields).filter((key) => !this.fields[key].hide);
      },
    },
    methods: {
      $_getFormattedValue(fieldKey, isFirst = true) {
        if (!this.modelData) return '';
        const value = isFirst
          ? this.getValueFunction.getFirstValue(this.modelData, fieldKey)
          : this.getValueFunction.getSecondValue(this.modelData, fieldKey);

        return this.fields[fieldKey].getText ? this.fields[fieldKey].getText(value) : value;
      },
      $_getErrorMessage(fieldKey) {
        if (!this.errorMessages) return null;
        return this.errorMessages[fieldKey] || null;
      },
      $_getParentState(fieldKey, modedFields) {
        const field = this.$_CMS_getFieldByFieldKey(fieldKey, modedFields);
        if (field.parentKey) {
          return this.updateData[field.parentKey];
        } else if (field.requiredField) {
          return this.updateData[field.requiredField];
        } else {
          return null;
        }
      },
      $_onInput(fieldKey,$event){
        this.$emit('input', {fieldKey, value:$event})
      },
      $_getValue(fieldKey) {
        return this.updateData
        ? this.updateData[fieldKey] !== undefined
        ? this.updateData[fieldKey]
        : this.$_getFormattedValue(fieldKey, false)
        : null
      }
    }
  }
</script>